import { Project } from "@/integrations/supabase/types/";
import { Card } from "@/components/ui/card";
import { Label } from "@/components/ui/label";
import { Calendar, DollarSign, User, Clock } from "lucide-react";

interface ProjectOverviewProps {
  project: Project;
  onUpdate: () => void;
}

export const ProjectOverview = ({ project }: ProjectOverviewProps) => {
  return (
    <div className="space-y-6">
      {/* Project Description */}
      <Card className="glass-card p-6">
        <h3 className="text-lg font-semibold mb-3">Project Description</h3>
        <p className="text-muted-foreground">
          {project.description || "No description provided"}
        </p>
      </Card>

      {/* Project Details Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Card className="glass-card p-6">
          <div className="flex items-center gap-3 mb-2">
            <Calendar className="h-5 w-5 text-primary" />
            <h4 className="font-semibold">Timeline</h4>
          </div>
          <div className="space-y-2 text-sm">
            <div>
              <Label className="text-muted-foreground">Start Date</Label>
              <p>{project.start_date ? new Date(project.start_date).toLocaleDateString() : 'Not set'}</p>
            </div>
            <div>
              <Label className="text-muted-foreground">Due Date</Label>
              <p>{project.due_date ? new Date(project.due_date).toLocaleDateString() : 'Not set'}</p>
            </div>
          </div>
        </Card>

        <Card className="glass-card p-6">
          <div className="flex items-center gap-3 mb-2">
            <DollarSign className="h-5 w-5 text-primary" />
            <h4 className="font-semibold">Budget</h4>
          </div>
          <div className="space-y-2 text-sm">
            <div>
              <Label className="text-muted-foreground">Total Budget</Label>
              <p className="text-2xl font-bold">${project.budget?.toLocaleString() || '0'}</p>
            </div>
          </div>
        </Card>

        <Card className="glass-card p-6">
          <div className="flex items-center gap-3 mb-2">
            <Clock className="h-5 w-5 text-primary" />
            <h4 className="font-semibold">Status</h4>
          </div>
          <div className="space-y-2 text-sm">
            <div>
              <Label className="text-muted-foreground">Current Status</Label>
              <p className="text-lg font-semibold capitalize">{project.status}</p>
            </div>
          </div>
        </Card>

        <Card className="glass-card p-6">
          <div className="flex items-center gap-3 mb-2">
            <User className="h-5 w-5 text-primary" />
            <h4 className="font-semibold">Created</h4>
          </div>
          <div className="space-y-2 text-sm">
            <div>
              <Label className="text-muted-foreground">Created At</Label>
              <p>{new Date(project.created_at).toLocaleDateString()}</p>
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
};
